'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _image_voucher = require('./image_voucher.jpg');

var _image_voucher2 = _interopRequireDefault(_image_voucher);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherCard = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VoucherCard, _Component);

  function VoucherCard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherCard.__proto__ || (0, _getPrototypeOf2.default)(VoucherCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showInfoDetail: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherCard, [{
    key: 'handleCloseModalDetail',
    value: function handleCloseModalDetail() {
      this.setState({ showInfoDetail: !this.state.showInfoDetail });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Voucher.scss');
      var item = this.props.item;

      var coupon = item.coupon || null;
      var showInfoDetail = this.state.showInfoDetail;

      return _react2.default.createElement(
        'div',
        { className: styles.voucherCard },
        _react2.default.createElement(
          'div',
          {
            className: styles.voucherCardImage,
            onClick: function onClick() {
              return _this2.handleCloseModalDetail();
            }
          },
          _react2.default.createElement('img', { src: coupon.image || _image_voucher2.default, alt: 'image voucher' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.voucherCardInfo },
          _react2.default.createElement(
            'div',
            { className: styles.code },
            item.code
          ),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            coupon.title
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.link,
              onClick: function onClick() {
                return _this2.handleCloseModalDetail();
              }
            },
            'T\xCCM HI\u1EC2U TH\xCAM'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showInfoDetail,
            hide: function hide() {
              return _this2.handleCloseModalDetail();
            },
            className: 'modal-voucher'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: function onClick() {
                return _this2.handleCloseModalDetail();
              }
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalHeader },
            _react2.default.createElement(
              'div',
              { className: styles.modalTitle },
              'Th\xF4ng tin voucher'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalBody },
            _react2.default.createElement(
              'div',
              { className: styles.primaryInfo },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                _react2.default.createElement('img', { src: coupon.image || _image_voucher2.default, alt: 'H\xECnh avatar' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.right },
                _react2.default.createElement(
                  'div',
                  { className: styles.title },
                  coupon.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.times },
                  'Hi\u1EC7u l\u1EF1c t\u1EEB ' + (0, _moment2.default)(new Date(coupon.start_date)).format('DD/MM/YYYY') + ' \u0111\u1EBFn ' + (0, _moment2.default)(new Date(coupon.end_date)).format('DD/MM/YYYY')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.description },
              _react2.default.createElement(
                'h2',
                null,
                '\xC1p d\u1EE5ng:'
              ),
              _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: coupon.description } })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.condition },
              _react2.default.createElement(
                'h2',
                null,
                '\u0110i\u1EC1u ki\u1EC7n s\u1EED d\u1EE5ng'
              ),
              _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: coupon.condition } })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contact },
              _react2.default.createElement(
                'h2',
                null,
                'Th\xF4ng tin li\xEAn h\u1EC7'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.address },
                coupon.address
              ),
              _react2.default.createElement(
                'div',
                { className: styles.phone },
                coupon.phone
              )
            )
          )
        )
      );
    }
  }]);
  return VoucherCard;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object
}, _temp2);
exports.default = VoucherCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/VoucherCard.js
// module id = 1505
// module chunks = 0